import createIcon from '../../createIcon';

/**
 * @component @name RvHookup
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTdWMTFDMTkgOS45IDE4LjEgOSAxNyA5SDZWN0wzIDEwTDYgMTNWMTFIMTBWMTRIM1YxN0MzIDE4LjEgMy45IDE5IDUgMTlIN0M3IDIwLjY2IDguMzQgMjIgMTAgMjJDMTEuNjYgMjIgMTMgMjAuNjYgMTMgMTlIMjFWMTdIMTlaTTEwIDIwQzkuNDUgMjAgOSAxOS41NSA5IDE5QzkgMTguNDUgOS40NSAxOCAxMCAxOEMxMC41NSAxOCAxMSAxOC40NSAxMSAxOUMxMSAxOS41NSAxMC41NSAyMCAxMCAyMFpNMTcgMTRIMTNWMTFIMTdWMTRaTTE2IDJWNEg4VjZIMTZWOEwxOSA1TDE2IDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RvHookup = createIcon('RvHookup', [
  [
    'path',
    {
      d: 'M19 17V11C19 9.9 18.1 9 17 9H6V7L3 10L6 13V11H10V14H3V17C3 18.1 3.9 19 5 19H7C7 20.66 8.34 22 10 22C11.66 22 13 20.66 13 19H21V17H19ZM10 20C9.45 20 9 19.55 9 19C9 18.45 9.45 18 10 18C10.55 18 11 18.45 11 19C11 19.55 10.55 20 10 20ZM17 14H13V11H17V14ZM16 2V4H8V6H16V8L19 5L16 2Z',
      key: 'gzzvq0',
    },
  ],
]);

export default RvHookup;
